{{#with printContextHandle}}
function void {{ setterName }}({{ type }} {{ identifier }});
  {{ ../type }}.{{ identifier }} = {{ identifier }};
endfunction
{{/with}}
